import { CheckIfttt3SupportStatusInModel } from '@/axios/IFttt.js'

const ifttt3Mixins = {
  data () {
    return {
      IFtttVersion: 2,
      ifttt3ToggerOkText: '',
      isSupportToggerflag: false,
      isSupportToggerflag2: false,
      SupportToggerVisible: false,
      newDeviceSelected: [],
      otaWarnFlag: false,
      otaGatewaySupportShow:false,
      OtaDeviceSupportList:[], // 网关或设备升级也不支持3.0
      iftttReverseValue1: 0,
      iftttReverseValue2: 0,
      iftttReverseValue3: 0,
      iftttReverseDelayTime: {},
      iftttReverseDialogVisible: false,
      webUpdateIsShow: true,
      otaUpdateIsShow: true,
    }
  },

  methods: {
    //网关或者设备升级是否支持3.0
    async isGatewayOrDeviceUpgradeSupported() {
      this.OtaDeviceSupportList = [];

      const res = await CheckIfttt3SupportStatusInModel(this.postdata);

      if (res?.StatusCode !== this.$store.state.rightStatusCode) return;
      
      res.Result.DeviceList?.forEach(item => {
        if (item.Gpno === 0) item.AreaName = this.$t('install.noarea')
        
        if (item.OtaDeviceSupport) {
          this.otaGatewaySupportShow = false
          this.webUpdateIsShow = true
        } else {
          this.otaWarnFlag = true
          this.otaGatewaySupportShow = true
          this.webUpdateIsShow = false
          this.otaUpdateIsShow = false
          if (!this.OtaDeviceSupportList.some(existing => existing.VDeviceId === item.VDeviceId)) {
            this.OtaDeviceSupportList.push(item)
          }
        }
      })
    },

    toggerModalClose(){
      if (this.isSupportToggerflag2) {
        // 跳转升级页面
        this.$router.push({name:'otatask'});
      }
      this.isSupportToggerflag = false;
      this.isSupportToggerflag2 = false;
      this.SupportToggerVisible = false;
    },
    
    // 判断自动化是2.0还是3.0 执行方式是否显示 编辑状态
    checkIftttVersionAndExecutionMode(rs){    
      if (this.pageType === 'edit') {
        this.IFtttVersion = rs?.Result?.IFtttVersion || rs?.IFtttVersion || 0

        if(this.IFtttVersion < 3){
          return false
        }
        if(this.triggermanual && this.triggermanual.length !== 0){
          return false
        }
        if(!this.$store.state.isNoLimit){
          return false
        }
        return true
      }
    },

    ifttt3Tip(flag, title) {

      if(!title) {
        return this.$t('iftttset.noSupportTip')
      }
      // 获取国际化翻译字符串
      let param = flag ? this.$t('iftttset.ifttt3Tip2') : this.$t('iftttset.ifttt3Tip')

      // 检查字符串中是否包含 '#' 字符
      if (param.indexOf('#') >= 0) {
        // 将字符串按 '#' 分割成数组
        param = param.split('#');
        
        // 如果分割后的数组长度为 5
        if (param.length === 3) {
          param = param[0]  + title + param[2];
          return param;
        }
      }
      
      // 如果不包含 '#' 或数组长度不为 5，返回原始翻译字符串
      return this.$t('iftttset.triggerandactiontip');
    },

    reverseAutomationTime(IFtttNo, _time = 0) {
      this.iftttReverseDelayTime[IFtttNo] = {}
      //给到的是秒,转换成时分秒 回显
      this.iftttReverseDelayTime[IFtttNo].hour = parseInt(_time / 3600) 
      this.iftttReverseDelayTime[IFtttNo].minute = parseInt((_time % 3600) / 60) 
      this.iftttReverseDelayTime[IFtttNo].second = parseInt((_time % 3600) % 60) 
      this.iftttReverseValue1 = parseInt(_time / 3600) + ''
      this.iftttReverseValue2 = parseInt((_time % 3600) / 60)  + ''
      this.iftttReverseValue3 = parseInt((_time % 3600) % 60) + ''

      if(
        this.iftttReverseDelayTime[IFtttNo].hour === 0 && 
        this.iftttReverseDelayTime[IFtttNo].minute === 0 && 
        this.iftttReverseDelayTime[IFtttNo].second === 0
      ) {
       this.iftttReverseDelayTime[IFtttNo] = {};
       this.iftttReverseDelayChecked = false;
       return
      }
      
      this.iftttReverseDelayChecked = true;
    },

    handleUpdateClose (done) {
      done && done()
    },
  }
};

export default ifttt3Mixins;